import router from '@/router';
// import { elealert } from '@/utils/ele';
import storage from '@/utils/storage';
import settings from '@/utils/settings'; //引入基础配置

router.beforeEach((to, from, next) => {
	const access_token = storage.get(settings.storagePrefix + 'access_token');

	if (access_token == '') {
		if (settings.whiteUrl.indexOf(to.path) !== -1) {
			//在路由白名单内
			next();
		} else {
			//否则跳转至登录页
			next({ path: '/login' });
		}
	} else {
		if (to.path === '/login') {
			//已经存在access_token时，若打开登录页则跳转至首页
			next({ path: '/home' });
		} else {
			if (to.path === '/') {
				next({ path: '/home' });
			} else {
				next();
			}
			// //验证菜单权限
			// const usermenulist = storage.get(settings.storagePrefix + 'usermenulist');
			// if (usermenulist.indexOf(to.path) !== -1) {
			// 	if (to.path === '/') {
			// 		next({ path: '/home' });
			// 	} else {
			// 		next();
			// 	}
			// } else {
			// 	elealert({ title: '提示', message: '您没有权限', type: 'error', confirmButtonText: '确定' });
			// }
		}
	}
});